import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewChildren } from '@angular/core';
import { MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';

import * as models from '../../models/ana-chat.models';
import * as config from '../../models/ana-config.models';
import * as vm from '../../models/ana-chat-vm.models';
import { StompService, StompConfig, StompConnectionStatus } from '../../services/stomp.service';

import { SimulatorService } from '../../services/simulator.service';

import { APIService } from '../../services/api.service';
import { UtilitiesService, Config } from '../../services/utilities.service';
import { ChainDelayService } from '../../services/chain-delay.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { InfoDialogService } from '../../services/info-dialog.service';
import { SampleService } from '../../services/resolver.service';
//import { SimulatorService } from '../../services/simulator.service';


@Component({
	selector: 'app-chat-thread',
	templateUrl: './chat-thread.component.html',
	styleUrls: ['./chat-thread.component.css']
})
export class ChatThreadComponent implements OnInit, AfterViewInit {

	ngAfterViewInit() {
		if (this.chatThreadView)
			this.chatThread.chatThreadView = this.chatThreadView.nativeElement;
	}

	constructor(
		private stompService: StompService,
		private apiService: APIService,
		private dialog: MdDialog,
		private sample: SampleService,
		private simulator:SimulatorService,
		private sanitizer: DomSanitizer,
		private infoDialog: InfoDialogService,
		private chainDelayService: ChainDelayService) {

		this.chatThread = new vm.ChatThreadVM(this.sanitizer);
		this.chatInput = new vm.ChatInputVM(this.dialog, this.chatThread, this.apiService, this.stompService, this, this.sanitizer);
	}
	@ViewChild("inputContainer")
	inputContainerRef: ElementRef;

	@ViewChild("chatThreadView")
	chatThreadView: ElementRef;

	@ViewChildren("carouselContainer")
	carouselContainers: ElementRef[];

	chatThread: vm.ChatThreadVM;
	chatInput: vm.ChatInputVM;
	settings: config.AppSettings;
	isMin: boolean = false;

	connectionStatusMessage() {
		if (!this.stompService)
			return '';
		switch (this.stompService.connectionStatus) {
			case StompConnectionStatus.Connected:
				return 'Available';
			case StompConnectionStatus.Connecting:
				return 'Trying to connect...';
			case StompConnectionStatus.Disconnected:
				return 'Not available';
			default:
				return '';
		}
	}
	setMin(min: boolean) {
		this.isMin = min;
	}
	carItemWidth: number = 245;
	scrollCarousel(carId: string, direction: string) {
		if (this.carouselContainers && this.carouselContainers.length > 0) {
			let carousels = this.carouselContainers.map(x => x.nativeElement as HTMLDivElement).filter(x => x.classList.contains(carId));
			if (carousels) {
				let car = carousels[0];
				if (direction == 'right') {
					if (car.scrollBy) {
						car.scrollBy({ behavior: 'smooth', left: this.carItemWidth }); //The 'left' value should be the width + margin of a single carousel item set in the CSS
					} else {
						car.scrollLeft += this.carItemWidth;
					}
				}
				else if (direction == 'left') {
					if (car.scrollBy) {
						car.scrollBy({ behavior: 'smooth', left: -this.carItemWidth });
					} else {
						car.scrollLeft -= this.carItemWidth;
					}
				}
			}
		}
	}

	canScrollCarousel(carId: string, direction: string) {
		return true;
		//Below implementation is not accurate.

		//if (this.carouselContainers && this.carouselContainers.length > 0) {
		//    let carousels = this.carouselContainers.map(x => x.nativeElement as HTMLDivElement).filter(x => x.classList.contains(carId));
		//    if (carousels) {
		//        let car = carousels[0];
		//        if (direction == 'right')
		//            return car.scrollLeft < car.scrollWidth;
		//        else if (direction == 'left')
		//            return car.scrollLeft > 0;
		//    }
		//}
	}

	isLastInMessageGroup(msg: vm.ChatMessageVM) {
		let msgsOnly = this.chatThread.messages.filter(x => x.getMessageContentType() != models.MessageContentType.Typing);
		var index = msgsOnly.indexOf(msg);
		if (index != -1) {
			if (index >= (msgsOnly.length - 1))
				return true;
			if (msgsOnly[index].direction != msgsOnly[index + 1].direction)
				return true;
		}
		return false;
	}
	isLastMessage(msg: vm.ChatMessageVM) {
		let msgsOnly = this.chatThread.messages.filter(x => x.getMessageContentType() != models.MessageContentType.Typing);
		var index = msgsOnly.indexOf(msg);
		return index == msgsOnly.length - 1;
	}
	handleCarouselClick(chatMessage: vm.ChatMessageVM, carOption: models.CarouselOption) {
		let carMsg = chatMessage.carouselMessageData();
		if (!carMsg.content.input)
			carMsg.content.input = {
				val: ""
			};
		if (carOption.type == models.ButtonType.URL) {
			let v = JSON.parse(carOption.value);
			carMsg.content.input.val = v.value;
			window.open(v.url, '_blank');
		} else
			carMsg.content.input.val = carOption.value;

		let msg = this.chatThread.addTextReply(carOption.title, UtilitiesService.uuidv4());
		this._sendMessageDelegate(new models.ANAChatMessage({
			meta: UtilitiesService.getReplyMeta(chatMessage.meta),
			data: carMsg
		}), msg);

		this.chatInput.resetInputs();
	}

	insertThreadMessageForCarouselInput(chatMessage: vm.ChatMessageVM) {
		try {
			let carMsg = chatMessage.carouselMessageData();
			let msg: vm.ChatMessageVM = null;
			carMsg.content.items.forEach(x => {
				try {
					x.options.forEach(y => {
						try {
							let value = "";
							if (y.type == models.ButtonType.URL) {
								let v = JSON.parse(y.value);
								value = v.value;
							} else
								value = y.value;

							if (value == carMsg.content.input.val)
								msg = this.chatThread.addTextReply(y.title, "", chatMessage.meta.timestamp, true);
						} catch (e) { console.log(e); }
					});
				} catch (e) { console.log(e); }
			});
			return msg;
		} catch (e) {
			console.log(e);
			return null;
		}
	}

	fetchingHistory: boolean = false;
	lastScrollTop: number = 0;
	chatThreadOnScroll(event: UIEvent) {
		if (!this.chatThread.chatThreadView) return;
		if (!this.settings || this.settings.simulatorMode) return;

		var currentScrollTop = this.chatThread.chatThreadView.scrollTop;
		if (currentScrollTop < this.lastScrollTop) {
			if (this.fetchingHistory)
				return;
			if (this.chatThread.chatThreadView) {
				if (this.chatThread.chatThreadView.scrollTop <= 2) {
					this.fetchingHistory = true;
					this.loadHistory(() => this.fetchingHistory = false);
				}
			}
		}
		this.lastScrollTop = currentScrollTop;
	}

	chatTextInputOnFocus() {
		this.chatThread.scrollLastIntoView(1000);
	}

	textInputFocus() {
		let ele = this.inputContainerRef.nativeElement as HTMLDivElement;
		if (ele) {
			setTimeout(() => {
				let inputEle = ele.querySelector('#chat-text') as HTMLInputElement;
				if (inputEle)
					inputEle.focus();
			}, 100);
		}
	}

	loadHistory(next: () => void) {
		if (!this.settings || this.settings.simulatorMode) return;
		let oldMsgTimestamp = ((this.chatThread.messages && this.chatThread.messages.length > 0) ? this.chatThread.messages[0].meta.timestamp : null);
		let oldScrollHeight: number = null;
		if (this.chatThread.chatThreadView)
			oldScrollHeight = this.chatThread.chatThreadView.scrollHeight;
		this.apiService.fetchHistory(oldMsgTimestamp).subscribe(resp => {
			try {
				let chatMsgs = resp.content.map(x => new models.ANAChatMessage(x));
				for (var i = 0; i < chatMsgs.length; i++) {
					let chatMsg = chatMsgs[i];
					let direction = chatMsg.meta.recipient.id == this.stompService.config.businessId ? vm.Direction.Outgoing : vm.Direction.Incoming;
					switch (chatMsg.data.type) {
						case models.MessageType.CAROUSEL:
							if (direction == vm.Direction.Incoming)
								this.chatThread.addMessage(new vm.ChatMessageVM(chatMsg, direction, ""), true);
							else if (direction == vm.Direction.Outgoing)
								this.insertThreadMessageForCarouselInput(new vm.ChatMessageVM(chatMsg, direction, ""));
							break;
						case models.MessageType.SIMPLE:
							if (direction == vm.Direction.Incoming) //Outgoing messages are never 'SIMPLE',  they are mostly 'INPUT' and rarely 'CAROUSEL'
								this.chatThread.addMessage(new vm.ChatMessageVM(chatMsg, direction, ""), true);
							break;
						case models.MessageType.INPUT:
							if (direction == vm.Direction.Outgoing) { //Ignore incoming input messages as their outgoing messages will be present (along with user given data).
								this.chatInput.insertThreadMessageForInput(new vm.ChatInputItemVM(chatMsg));
							}
							break;
						default:
							break;
					}
				}

				if (!oldMsgTimestamp) { //Display input and scroll to last only for page 0 of the history (latest page)
					if (chatMsgs[0] && chatMsgs[0].data.type == models.MessageType.INPUT) {
						let inputContent = chatMsgs[0].data.content as models.InputContent;
						if (!inputContent.input || Object.keys(inputContent.input).length <= 0)
							this.chatInput.setInput(new vm.ChatInputItemVM(chatMsgs[0]));
					}
					this.chatThread.scrollToLast();
				}
				else {
					if (oldScrollHeight && this.chatThread.chatThreadView) {
						window.requestAnimationFrame(() => {
							this.chatThread.chatThreadView.scrollTop = (this.chatThread.chatThreadView.scrollHeight - oldScrollHeight);
						});
					}
				}
			} catch (e) { console.log(e); }
			if (next)
				next();
		}, err => {
			if (next)
				next();
		});
	}

	_handleMessageReceivedDelegate = (message) => {
		if (this.settings && this.settings.stompConfig && this.settings.stompConfig.debug) {
			console.log("Socket Message Received: ");
			console.log(message);
		}

		switch (message.data.type) {
			case models.MessageType.INPUT:
				{
					this.chainDelayService.delay((queueLength) => {
						this.chatInput.resetInputs(); //Currently only one input item is supported
						this.chatInput.setInput(new vm.ChatInputItemVM(message));
						this.chatThread.removeTyping();
						this.textInputFocus();
					}, 0);
					break;
				}
			case models.MessageType.SIMPLE:
			case models.MessageType.CAROUSEL:
				{
					this.chatThread.setTyping();
					this.chainDelayService.delay((queueLength) => {
						let msg = new vm.ChatMessageVM(message, vm.Direction.Incoming, "");
						this.chatThread.addMessage(msg);

						if (message.data.type == models.MessageType.CAROUSEL) {
							let carItemsWithOptions = msg.carouselMessageData().content.items.filter(x => x.options && x.options.length > 0).length;
							if (carItemsWithOptions > 0) //Hide the fixed input textbox if carousel has options
								this.chatInput.resetInputs();
						}
						if (queueLength > 0)
							this.chatThread.setTyping();
					}, 2000);
					break;
				}
			default:
				console.log(`Unsupported message type: ${models.MessageType[message.data.type]}`);
		}
	};
	_sendMessageDelegate: (message: models.ANAChatMessage, threadMsgRef: vm.ChatMessageVM) => void;

	removeConsecutiveErrorsMessage() {
		let oldMsgIdx = this.chatThread.messages.findIndex(x => x.messageAckId == Config.consecutiveErrorsMessageAckId);
		if (oldMsgIdx != -1)
			this.chatThread.messages.splice(oldMsgIdx, 1);
	}

	openWindow(url: string | SafeUrl) {
		if (typeof url == 'string')
			window.open(url);
		else if (typeof url == 'object') {
			window.open((<any>url).changingThisBreaksApplicationSecurity);
		}
	}

	getStarted(clearThread: boolean, askConfirmation: boolean) {
		if (askConfirmation) {
			this.infoDialog.confirm("Start a fresh chat?", "Restarting the chat will clear current chat messages. Are you sure?", (ok) => {
				if (ok) {
					this.getStarted(true, false);
				}
			}, "Yes", "No");
			return;
		}
		if (clearThread) {
			this.fetchingHistory = true;
			setTimeout(() => this.fetchingHistory = false, 1000);

			this.chatThread.messages = [];
			this.chatInput.resetInputs();
		}
		let firstMsg = new models.ANAChatMessage({
			"meta": {
				"sender": {
					"id": this.stompService.config.businessId,
					"medium": 3
				},
				"recipient": {
					"id": this.stompService.config.customerId,
					"medium": 3
				},
				"senderType": models.SenderType.USER,
				"flowId": this.stompService.config.flowId,
				"previousFlowId": this.stompService.config.flowId,
				"currentFlowId": this.stompService.config.flowId,
				"timestamp": new Date().getTime(),
			},
			"data": {
				"type": 2,
				"content": {
					"inputType": models.InputType.OPTIONS,
					"mandatory": 1,
					"options": [
						{
							"title": "Get Started",
							"value": "GetStarted"
						}
					],
					"input": {
						"val": "GET_STARTED"
					}
				}
			},
			"events": [
				{
					"type": models.EventType.SET_SESSION_DATA,
					"data": JSON.stringify(UtilitiesService.settings.appConfig.initVerbs)
				}
			]
		});
		let msg = new vm.ChatMessageVM(firstMsg, vm.Direction.Outgoing, UtilitiesService.uuidv4()); //Pseudo, not actually added to thread. 
		this._sendMessageDelegate(new models.ANAChatMessage({
			meta: UtilitiesService.getReplyMeta(firstMsg.meta),
			data: firstMsg.data,
			events: firstMsg.events
		}), msg);
	}

	MH = new ModelHelpers();
	ngOnInit() {
		this.settings = UtilitiesService.settings;
		if (this.settings && this.settings.stompConfig) {
			this._sendMessageDelegate = (a, b) => this.stompService.sendMessage(a, b);

			this.stompService.handleMessageReceived = this._handleMessageReceivedDelegate;
			this.stompService.handleConnect = () => {
				if (this.chatThread.messages.length <= 0) {
					this.getStarted(false, false);
				} else {
					//Retrying all pending messages in the chat thread.
					this.removeConsecutiveErrorsMessage();
					let pendingMsgs = this.chatThread.messages.filter(x => x.status == vm.MessageStatus.SentTimeout || x.status == vm.MessageStatus.SentToServer && x.retrySending);
					pendingMsgs.forEach(x => x.retrySending());
				}
			};
			this.stompService.handleAck = (messageAckId: string, deliveredAck?: boolean) => {
				if (deliveredAck) {
					//For deliveredAck, msgAckId is the msg.meta.id
					let msg = this.chatThread.messages.find(x => x.meta.id == messageAckId);
					if (msg) {
						msg.status = vm.MessageStatus.DelieveredToTarget;
						msg.clearTimeoutTimer();
					}
				} else {
					let msg = this.chatThread.messages.find(x => x.messageAckId == messageAckId);
					if (msg) {
						msg.status = vm.MessageStatus.ReceivedAtServer;
						msg.clearTimeoutTimer();
					}
				}
			};
			this.stompService.handleTyping = () => {
				this.chatThread.setTyping();
			};
			this.stompService.handleConsecutiveErrorsState = () => {
				this.removeConsecutiveErrorsMessage();
				this.chatThread.addTextIncoming(Config.consecutiveErrorsMessageText, Config.consecutiveErrorsMessageAckId);
			};
			this.loadHistory(() => {
				try {
					if (window.parent && window.parent.postMessage) {
						window.parent.postMessage({
							type: "LOADED"
						}, "*");
					}
				} catch (e) { }
				this.stompService.connect()
			});
		}
		//debugger
		//console.log("settings"+JSON.stringify(this.settings))
		if (this.settings.simulatorMode) {
			this.fetchingHistory = false;
			SampleService.handleMessageReceived = this._handleMessageReceivedDelegate;
			this.simulator.handleMessageReceived = this._handleMessageReceivedDelegate;
			//console.log("simulatorr"+this.simulator.handleMessageReceived)
			//console.log("sample service"+SampleService.handleMessageReceived)

			this.simulator.handleResetSignal = () => {
				this.chatThread.messages = [];
				this.chatInput.resetInputs();
			};
			this._sendMessageDelegate = (a, b) => this.simulator.sendMessage(a, b);
		}
	}

	carouselItemHasMedia(carItem: models.CarouselItem) {
		return carItem.media && (carItem.media.type != null || carItem.media.type != undefined) && carItem.media.url;
	}
}

export class ModelHelpers {
	Direction = vm.Direction;
	MessageStatus = vm.MessageStatus;
	MessageType = models.MessageType;
	MessageContentType = models.MessageContentType;
	MediaType = models.MediaType;
	InputType = models.InputType;
	StompConnectionStatus = StompConnectionStatus;
}


// WEBPACK FOOTER //
// D:/NOWFLOATS/ana-web-chat-master-f726fd66c7ed228fb0b4a1e0e71ea760bd266a85/src/app/components/chat-thread/chat-thread.component.ts